import Home from './components/home';
import GlobalStyle from './theme/global';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

function App() {
	return (
		<>
			<GlobalStyle />
			<Home />
		</>
	);
}

export default App;
